import { LocationFilters, UpdateStatusFilter } from "../types";

export enum TypeKeys {
    CLEAR_FILTERS = "LOCATION_RELATIONS/CLEAR_FILTERS",
    SET_ACTIVE_FILTERS = "LOCATION_RELATIONS/SET_ACTIVE_FILTERS",
    SET_UPDATE_STATUS_FILTERS = "LOCATION_RELATIONS/SET_UPDATE_STATUS_FILTERS",
    SET_TEXT_FILTER = "LOCATION_RELATIONS/SET_TEXT_FILTER",
}
export const createAction = {
    clearFilters: () => ({ type: TypeKeys.CLEAR_FILTERS }),
    setFilters: (filters: LocationFilters) => ({ type: TypeKeys.SET_ACTIVE_FILTERS, filters }),
    setStatusFilters: (filters: UpdateStatusFilter[]) => ({ type: TypeKeys.SET_UPDATE_STATUS_FILTERS, filters }),
    setTextFilter: (text: string) => ({ type: TypeKeys.SET_TEXT_FILTER, text }),
};

type ClearFiltersAction = { type: TypeKeys.CLEAR_FILTERS };
type SetActiveFiltersAction = { type: TypeKeys.SET_ACTIVE_FILTERS; filters: LocationFilters };
type SetFilterTextAction = { type: TypeKeys.SET_TEXT_FILTER; text: string };
type SetStatusFilters = { type: TypeKeys.SET_UPDATE_STATUS_FILTERS; filters: UpdateStatusFilter[] };

type FilterAction = ClearFiltersAction | SetActiveFiltersAction | SetStatusFilters | SetFilterTextAction;

export interface State {
    active: LocationFilters;
    text: string;
}

export function getInitialState(): State {
    return {
        active: {
            updateStatus: [],
        },
        text: "",
    };
}

export function reducer(state: State = getInitialState(), action: FilterAction): State {
    if (action.type === TypeKeys.CLEAR_FILTERS) {
        return getInitialState();
    }

    if (action.type === TypeKeys.SET_ACTIVE_FILTERS) {
        const { filters } = action;

        return {
            ...state,
            active: filters,
        };
    }

    if (action.type === TypeKeys.SET_UPDATE_STATUS_FILTERS) {
        const { filters } = action;

        const initialState = getInitialState();

        return {
            ...initialState,
            active: {
                updateStatus: filters,
            },
        };
    }

    if (action.type === TypeKeys.SET_TEXT_FILTER) {
        const { text } = action;

        return {
            ...state,
            text,
        };
    }

    return state;
}
